// What a signed-in user leaves in this browser that the next user must not
// see. Called whenever a session ends (auth/session.ts): a sign-out, even
// one that leaves the page, a rejected refresh, an expiry, another tab.

import { clearDiagnostics } from "@jkast90/kast-common/diagnostics";
import { removeKeys } from "@jkast90/kast-common/storage";

/**
 * Written by the API history and telemetry this app had before the
 * shared diagnostics module. Nothing writes them now; they are removed so a
 * browser that still holds them (API paths, a copy of the Redux store) is
 * wiped at the next sign-out.
 */
const LEGACY_KEYS = [
  "kindly_api_call_history",
  "kindly_telemetry_data",
  "kindly_breadcrumbs",
  "kindly_state_snapshots",
];

export function clearUserData(): void {
  clearDiagnostics();
  removeKeys(LEGACY_KEYS);
  try {
    removeKeys(["kindly_session_telemetry"], { storage: sessionStorage });
  } catch {
    // sessionStorage itself is blocked: there is nothing stored to clear.
  }
}
